import { useQuery } from '@tanstack/react-query';
import { getTradeItemTimeline } from '../orders.api';

export function useGtinTimeline(tradeItemId: string) {
  return useQuery({
    queryKey: ['orders', 'gtinTimeline', tradeItemId],
    queryFn: () => getTradeItemTimeline(tradeItemId),
    staleTime: 30 * 1000,
    enabled: tradeItemId !== '',
  });
}
